import { memo } from 'react';

import withExposer from '@/hocs/with-exposer';
import { SecondaryNavLink } from '@/state/slices/secondary-nav/typings';
import { BasicComponentProps } from '@/typings/generic';

interface BreadcrumbPrevLinkProps extends BasicComponentProps {
	previousLink?: SecondaryNavLink;
}

const BreadcrumbPrevLinkComponent: React.FC<BreadcrumbPrevLinkProps> = ({
	previousLink,
}) => {
	if (!previousLink?.title || !previousLink?.evaluatedLink) return null;

	return (
		<a
			className='dxnav__breadcrumb-prev-link'
			href={previousLink.evaluatedLink}
		>
			<svg className='dxnav-icon'>
				<use xlinkHref='#Chevron_Right'></use>
			</svg>
			<span className='dxnav__breadcrumb-prev-text'>
				{previousLink.title}
			</span>
		</a>
	);
};

const BreadcrumbPrevLink = memo(
	withExposer(BreadcrumbPrevLinkComponent, 'breadcrumb_prev_link'),
);

export default BreadcrumbPrevLink;
